import { OnboardingProgress } from "@/types/OnboardingProgress";
import { apiGet, apiPut } from "../_apiShim";

const BASE_PATH = "/api/v1/onboarding";

/**
 * Get onboarding progress for a company.
 * GET /api/v1/onboarding/{companyId}
 */
export async function getOnboardingProgress(
  companyId: string,
  fields?: string,
): Promise<OnboardingProgress> {
  const query = fields ? `?fields=${encodeURIComponent(fields)}` : "";
  const url = `${BASE_PATH}/${companyId}${query}`;

  const headers: Record<string, string> = {
    "Cache-Control": "no-store",
  };
  return await apiGet<OnboardingProgress>(url, headers, true);
}

/**
 * Complete an onboarding step.
 * PUT /api/v1/onboarding/{companyId}/complete-step
 */
export async function completeOnboardingStep(
  companyId: string,
  stepKey: string,
): Promise<void> {
  const url = `${BASE_PATH}/${companyId}/complete-step`;

  const headers: Record<string, string> = {};
  await apiPut<void>(url, { stepKey }, headers);
}

/**
 * Update onboarding state (dismissed/minimized).
 * PUT /api/v1/onboarding/{companyId}/state
 */
export async function updateOnboardingState(
  companyId: string,
  body: {
    dismissed?: boolean;
    minimized?: boolean;
    welcomeShown?: boolean;
    tourState?: "PENDING" | "COMPLETED" | "SKIPPED";
  },
): Promise<void> {
  const url = `${BASE_PATH}/${companyId}/state`;

  const headers: Record<string, string> = {};
  await apiPut<void>(url, body, headers);
}

/**
 * Reset onboarding progress.
 * PUT /api/v1/onboarding/{companyId}/reset
 */
export async function resetOnboarding(
  companyId: string,
): Promise<void> {
  const url = `${BASE_PATH}/${companyId}/reset`;

  const headers: Record<string, string> = {};
  await apiPut<void>(url, {}, headers);
}
